import {
  CONSUMER_CMS_SHOPPING_CART,
  IDeliveryInformationMobile,
  IGenericErrorCMS,
  productSpecificError,
  useCmsConfig,
} from '@vfit/consumer/data-access';
import { API, requireStaticImageAtomComponent } from '@vfit/shared/data-access';
import React, { useEffect } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { ShadowsGroup } from '@vfit/shared/components';
import { resetData, ITrackError } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { ICommonData, IValidAddressList } from '@vfit/shared/models';
import { useCheckout } from '../../../../../iBuyMobile.context';
import { TextLoaderEmpty, Container } from './postAddress.style';
import { useDeliveryPostFlow } from '../../../../hooks/UseDeliveryPostFlow/useDeliveryPostFlow';

const PostAddress = ({ handleGoPrevSlide, handleOnChangeEnableGoNext }: ICommonData) => {
  const queryClient = useQueryClient();
  const {
    isModalButtonSticky,
    product,
    shippingAddress,
    pickupPoint,
    checkoutErrors,
    setIsDisabledBackButton,
    setIsNewShippingAddress,
    setIsStartDeliveryBase,
  } = useCheckout();
  const { validateAddress, deliveryEvolved, createAddress, postDelivery, individual, linkContact } =
    useDeliveryPostFlow({
      pickupPoint,
      shippingAddress: shippingAddress as unknown as IValidAddressList,
    });
  const deliveryInformation = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_DELIVERY_INFORMATION_MOBILE
  ) as IDeliveryInformationMobile;
  const genericError = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_GENERIC_ERROR_MOBILE
  ) as IGenericErrorCMS;
  const { buttonGenericError } = productSpecificError(product);

  const isLoadingState = () =>
    validateAddress?.isLoading ||
    deliveryEvolved?.isLoading ||
    createAddress?.isLoading ||
    postDelivery.isLoading ||
    individual.isLoading ||
    linkContact.isLoading;

  const isErrorState = () =>
    validateAddress?.isError ||
    deliveryEvolved?.isError ||
    createAddress?.isError ||
    individual?.isError ||
    postDelivery?.isError ||
    linkContact?.isError;

  const getError = (): ITrackError | undefined => {
    if (validateAddress?.isError) return validateAddress?.error;
    if (deliveryEvolved?.isError) return deliveryEvolved?.error;
    if (createAddress?.isError) return createAddress?.error;
    if (individual?.isError) return individual?.error;
    if (postDelivery?.isError) return postDelivery?.error;
    if (linkContact?.isError) return linkContact?.error;
    return undefined;
  };

  const managePostState = () => {
    if (isLoadingState()) handleOnChangeEnableGoNext?.(false);

    setIsDisabledBackButton(isLoadingState());

    if (isErrorState()) {
      const error = getError();
      checkoutErrors?.showAndTrackError?.(
        genericError,
        handleGoPrevSlide,
        error,
        deliveryInformation?.deliveryinformationm?.errorCards?.addressResponse?.title || '',
        deliveryInformation?.deliveryinformationm?.errorCards?.addressResponse?.message || '',
        handleGoPrevSlide,
        buttonGenericError,
        undefined,
        undefined,
        isModalButtonSticky
      );
    }
  };

  useEffect(() => {
    if (postDelivery.isSuccess) {
      setIsNewShippingAddress(false);
      resetData(queryClient, ['deliveryDetailsIsBaseMobile']);
      setIsStartDeliveryBase(true);
    }
  }, [postDelivery.isSuccess]);

  useEffect(() => {
    managePostState();
  }, [deliveryEvolved, validateAddress, createAddress, postDelivery, individual, linkContact]);

  const renderPostAddress = () => {
    if (isLoadingState()) {
      if (product?.loaders?.yourAddressCard) {
        return (
          <Container>
            <TextLoaderEmpty />
            <Player
              src={requireStaticImageAtomComponent(product.loaders.yourAddressCard).src}
              className="player"
              loop
              autoplay
            />
          </Container>
        );
      }
      return <ShadowsGroup quantity={2} heights={90} />;
    }
    return null;
  };

  return renderPostAddress();
};

export default PostAddress;

